// extracted by mini-css-extract-plugin
export default {"link":"QualityQuantity_link__MQHak","clickable":"QualityQuantity_clickable__nwuOy"};